import { ApiCategoryTask } from '../api-types/category-task.api';
import { CategoryTask } from '../app-types/category-tast.app';

export const transformApiCategoryTaskToAppCategoryTask = (input: ApiCategoryTask): CategoryTask => {
	return {
		id: input.id,
		description: input.description,
		helpText: input.helpText,
		initial: input.initial,
		validForP2: input.validForP2,
		validForP3: input.validForP3,
	};
};

export const transformApiCategoryTasksToAppCategoryTasks = (input: ApiCategoryTask[]): CategoryTask[] => {
	return input.map(transformApiCategoryTaskToAppCategoryTask);
};
